import { Document } from '@rossum/api-client/documents';
import { IconCornerDownRight, IconFileTypeZip } from '@rossum/ui/icons/tabler';
import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  SvgIcon,
} from '@rossum/ui/material';
import { borderRadius } from '@rossum/ui/theme';
import { useOpenDocument } from './hooks/useOpenDocument';

type Props = {
  document: Document;
  isChild: boolean;
};

export const DocumentInfo = ({ document, isChild }: Props) => {
  const { mutate: loadDocument } = useOpenDocument();
  return (
    <ListItemButton
      onClick={() => document.content && loadDocument(document.content)}
      disabled={!document.content}
      disableGutters
      sx={{ py: 0, px: 2, borderRadius: borderRadius('s') }}
    >
      {isChild && (
        <SvgIcon
          fontSize="medium"
          sx={{ color: theme => theme.palette.text.secondary }}
        >
          <IconCornerDownRight />
        </SvgIcon>
      )}
      {document.attachmentStatus === 'extracted_archive' && (
        <ListItemIcon sx={{ minWidth: 24 }} data-cy="document-zip">
          <SvgIcon
            fontSize="large"
            sx={{
              width: 20,
              height: 20,
              color: theme => theme.palette.text.secondary,
            }}
          >
            <IconFileTypeZip />
          </SvgIcon>
        </ListItemIcon>
      )}
      <ListItemText sx={{ py: 0.5 }}>{document.originalFileName}</ListItemText>
    </ListItemButton>
  );
};
